import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface AdminUser {
  id: number;
  rid: number;
  level: string;
  name: string;
  user_name: string;

  login?: string;
  mail?: string;
}

export interface AdminUserResponse {
  success: boolean;
  status: number;
  body: AdminUser[];
}

@Injectable({ providedIn: 'root' })
export class AdminUsersService {

  constructor(private http: HttpClient) {}

  getAdminUsers(): Observable<AdminUserResponse> {
    return this.http.get<AdminUserResponse>('/api/druser/admin-users');
  }

  searchUsers(login: string, name: string, cap_id: string): Observable<AdminUserResponse> {
    const params = new HttpParams().set('login', login).append('name', name).append('cap_id', cap_id);
    return this.http.get<AdminUserResponse>('/api/druser/search-users', {params});
  }

  parseData(res: AdminUserResponse) {
    return res.body.map(x => {
      x.id = parseInt(x.id as any);
      x.rid = parseInt(x.rid as any);
      return x;
    });
  }

  updateEmail(id: number, email: string): Observable<AdminUserResponse> {
    const params = new HttpParams().set('id', id).append('email', email);
    return this.http.get<AdminUserResponse>('/api/druser/update-email', {params});
  }
}
